import './challenge-status.scss';
import { useState } from 'react';
import Button from '../button/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import UtilsService from '../../services/utils-service';
import TranslateService from '../../services/translate-service';
import LocalStorage from '../../services/local-storage';
import { SESSION, SCORE, ASSETS } from '../../constants';
import Avatar from  '../avatar/avatar';

export default function ChallengeStatus(props) {

    const [session] = useState(LocalStorage.get(SESSION));
    const [score] = useState(LocalStorage.get(SCORE) || 0);

    const [activeIndex, setActiveIndex] = useState(0);

    const prev = () => {
        setActiveIndex(activeIndex - 1)
    }

    const next = () => {
        setActiveIndex(activeIndex + 1)
    }

    const getTotalWon = (itsMe) => {
        return itsMe ?
            props.data.retoActual.rondas.filter(round => round.ganador && round.ganador === session._id).length :
            props.data.retoActual.rondas.filter(round => round.ganador && round.ganador !== session._id).length;
    }

    const getWinner = (round, itsMe) => {
        if (!round.ganador) return '-';

        if (itsMe) {
            return round.ganador === session._id ? 'x' : '-';
        } else {
            return round.ganador !== session._id ? 'x' : '-';
        }

    }

    const getRightAnswers = (round, itsMe) => {
        const jugador = getInfoPlayer(round, itsMe);
        if (!jugador) return '-';

        const total = jugador.estadisticas.filter(e => e.esCorrecta).length;

        return total;
    }

    const getTime = (round, itsMe) => {
        const jugador = getInfoPlayer(round, itsMe);
        if (!jugador) return '-';

        const total = jugador.estadisticas.filter(e => e.esCorrecta).reduce((a, b) => a + b.tiempo, 0);

        return UtilsService.round(total);
    }

    const getAccuracy = (round, itsMe) => {
        const jugador = getInfoPlayer(round, itsMe);
        if (!jugador) return '-';

        const total = jugador.estadisticas.filter(e => e.esCorrecta).length;
        const accuracy = (total * 100) / jugador.estadisticas.length;
        return `${UtilsService.round(accuracy)}%`;
    }

    const getInfoPlayer = (round, itsMe) => {
        if (itsMe) {
            return round.jugador1.jugador === session._id ? round.jugador1 : round.jugador2;
        } else {
            return round.jugador1.jugador !== session._id ? round.jugador1 : round.jugador2;
        }
    }

    const getRoundLabel = () => {
        let text = TranslateService.get('modal.statusChallenge.round');

        text = text.replace('{current}', activeIndex + 1);
        text = text.replace('{total}', props.data.retoActual.totalRondas);

        return text;
    }

    return (
        <div className='challenge-status'>
            <div className='text-center mb-[40px]'>
                <h1 className='heading-h1'>
                    {props.data.status === 'ongoing' && '🕐'}
                    {props.data.status === 'lost' && '😕'}
                    {props.data.status === 'won' && '😎'}
                </h1>
                {props.data.status === 'ongoing' && <h1 className='heading-h3 mt-4 won-color'>{TranslateService.get('modal.statusChallenge.title.ongoing')}</h1>}
                {props.data.status === 'lost' && <h1 className='heading-h3 mt-4 won-color'>{TranslateService.get('modal.statusChallenge.title.lost')}</h1>}
                {props.data.status === 'won' && <h1 className='heading-h3 mt-4 won-color'>{TranslateService.get('modal.statusChallenge.title.won')}</h1>}

            </div>

            <div className='grid gap-[16px] grid-cols-12'>
                <div className='col-span-8 col-start-3'>

                    <div className='grid gap-[16px] grid-cols-12 items-center  mb-[11px]'>
                        <div className='col-span-4 '>
                            <div className='text-center'>
                                <Avatar className='mx-auto' image={`${ASSETS.AVATAR_PLAYER}${session.avatar}`} />
                                <h1 className='heading-h5 mt-1 won-color'>{TranslateService.get('modal.statusChallenge.you')}</h1>
                                <p className='heading-h6 !text-secundary mt-1 won-color'>{UtilsService.format(score)}pts</p>
                            </div>
                        </div>

                        <div className='col-span-4 '>
                            <div className='text-center won-score m-auto'>
                                <h1 className='heading-h5 won-color'>{getTotalWon(true)} : {getTotalWon(false)}</h1>
                            </div>
                        </div>
                        <div className='col-span-4 '>
                            <div className='text-center'>
                                <Avatar className='mx-auto' image={`${ASSETS.AVATAR_PLAYER}${props.data.oponente.avatar}`} />
                                <h1 className='heading-h5 mt-1 won-color'>{UtilsService.formatPlayerName(props.data.oponente.nombre, props.data.oponente.apellidoPaterno)}</h1>
                                <p className='heading-h6 !text-secundary mt-1 won-color'>{UtilsService.format(props.data.oponente.puntosAreas.puntos)}pts</p>
                            </div>
                        </div>
                    </div>



                    <div className='grid gap-[16px] grid-cols-12 items-center  mb-[49px]'>
                        <div className='col-span-12 '>

                            <div className='card !rounded-[20px] !p-[24px]'>

                                <div className='grid gap-[16px] grid-cols-12 items-center '>
                                    <div className='col-span-3 text-right '>
                                        <button className='btn-fa' disabled={activeIndex === 0} onClick={prev}>
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </button>

                                    </div>
                                    <div className='col-span-6 text-center'>
                                        <p className='heading-h6 !text-default'>{getRoundLabel()}</p>
                                    </div>
                                    <div className='col-span-3 text-left'>
                                        <button className='btn-fa' disabled={activeIndex === (props.data.retoActual.rondas.length - 1)} onClick={next}>
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </button>

                                    </div>
                                </div>

                                <div className='overflow-hidden'>

                                    <div className='inner' style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
                                        {props.data.retoActual.rondas.map(round => (
                                            <div className='inline-block w-full' key={round._id}>
                                                <div className='grid gap-[16px] grid-cols-12 items-center mt-6 pb-6 separator-bottom'>
                                                    <div className='col-span-3 '>
                                                        <p className='text-heading-default'>{getWinner(round, true)}</p>
                                                    </div>
                                                    <div className='col-span-6 text-center'>
                                                        <p className='text-secundary'>{TranslateService.get('modal.statusChallenge.winner')}</p>
                                                    </div>
                                                    <div className='col-span-3 text-right'>
                                                        <p className='text-heading-default'>{getWinner(round, false)}</p>
                                                    </div>
                                                </div>

                                                <div className='grid gap-[16px] grid-cols-12 items-center  mt-6'>
                                                    <div className='col-span-3 '>
                                                        <p className='text-heading-default'>{getRightAnswers(round, true)}</p>
                                                    </div>
                                                    <div className='col-span-6 text-center'>
                                                        <p className='text-secundary'>{TranslateService.get('modal.statusChallenge.right')}</p>
                                                    </div>
                                                    <div className='col-span-3 text-right'>
                                                        <p className='text-heading-default'>{getRightAnswers(round, false)}</p>
                                                    </div>
                                                </div>

                                                <div className='grid gap-[16px] grid-cols-12 items-center mt-6'>
                                                    <div className='col-span-3 '>
                                                        <p className='text-heading-default'>{getTime(round, true)}</p>
                                                    </div>
                                                    <div className='col-span-6 text-center'>
                                                        <p className='text-secundary'>{TranslateService.get('modal.statusChallenge.time')}</p>
                                                    </div>
                                                    <div className='col-span-3 text-right'>
                                                        <p className='text-heading-default'>{getTime(round, false)}</p>
                                                    </div>
                                                </div>

                                                <div className='grid gap-[16px] grid-cols-12 items-center mt-6'>
                                                    <div className='col-span-3 '>
                                                        <p className='text-heading-default'>{getAccuracy(round, true)}</p>
                                                    </div>
                                                    <div className='col-span-6 text-center'>
                                                        <p className='text-secundary'>{TranslateService.get('modal.statusChallenge.effectivity')}</p>
                                                    </div>
                                                    <div className='col-span-3 text-right'>
                                                        <p className='text-heading-default'>{getAccuracy(round, false)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                    {!props.hideBtnDone && 
                        <div className='text-center'>
                            <Button className='small !px-[31px]' onClick={props.onClose}>{TranslateService.get('modal.statusChallenge.btn')}</Button>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}